@file:OptIn(InternalResourceApi::class)

package aicombo.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/aicombo.composeapp.generated.resources/"

internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/titles.commonMain.cvr", 10, 32),
        ResourceItem(setOf(), "${MD}values/titles.commonMain.cvr", 10, 24),
      ))
    }

internal val Res.string.navigation_chat_gpt_title: StringResource by lazy {
      StringResource("string:navigation_chat_gpt_title", "navigation_chat_gpt_title", setOf(
        ResourceItem(setOf(), "${MD}values/navigation_strings.commonMain.cvr", 10, 45),
      ))
    }

internal val Res.string.navigation_generation_title: StringResource by lazy {
      StringResource("string:navigation_generation_title", "navigation_generation_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/navigation_strings.commonMain.cvr", 10, 59),
        ResourceItem(setOf(), "${MD}values/navigation_strings.commonMain.cvr", 56, 51),
      ))
    }

internal val Res.string.navigation_library_title: StringResource by lazy {
      StringResource("string:navigation_library_title", "navigation_library_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/navigation_strings.commonMain.cvr", 70, 60),
        ResourceItem(setOf(), "${MD}values/navigation_strings.commonMain.cvr", 108, 44),
      ))
    }

internal val Res.string.navigation_main_title: StringResource by lazy {
      StringResource("string:navigation_main_title", "navigation_main_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/navigation_strings.commonMain.cvr", 131, 49),
        ResourceItem(setOf(), "${MD}values/navigation_strings.commonMain.cvr", 153, 37),
      ))
    }

internal val Res.string.navigation_profile_title: StringResource by lazy {
      StringResource("string:navigation_profile_title", "navigation_profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/navigation_strings.commonMain.cvr", 181, 52),
        ResourceItem(setOf(), "${MD}values/navigation_strings.commonMain.cvr", 191, 44),
      ))
    }

internal val Res.string.navigation_settings_title: StringResource by lazy {
      StringResource("string:navigation_settings_title", "navigation_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/navigation_strings.commonMain.cvr", 234, 57),
        ResourceItem(setOf(), "${MD}values/navigation_strings.commonMain.cvr", 236, 45),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("navigation_chat_gpt_title", Res.string.navigation_chat_gpt_title)
  map.put("navigation_generation_title", Res.string.navigation_generation_title)
  map.put("navigation_library_title", Res.string.navigation_library_title)
  map.put("navigation_main_title", Res.string.navigation_main_title)
  map.put("navigation_profile_title", Res.string.navigation_profile_title)
  map.put("navigation_settings_title", Res.string.navigation_settings_title)
}
